import i18n from 'i18next';
import type { ResourceLanguage } from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';
import { DEFAULT_LOCALE } from '../constants';

import enUS from '../../../../locales/en-US.json';
import daDK from '../../../../locales/da-DK.json';
import deDE from '../../../../locales/de-DE.json';
import enAU from '../../../../locales/en-AU.json';
import enCA from '../../../../locales/en-CA.json';
import enGB from '../../../../locales/en-GB.json';
import esES from '../../../../locales/es-ES.json';
import esMX from '../../../../locales/es-MX.json';
import frCA from '../../../../locales/fr-CA.json';
import frFR from '../../../../locales/fr-FR.json';
import itIT from '../../../../locales/it-IT.json';
import jaJP from '../../../../locales/ja-JP.json';
import koKR from '../../../../locales/ko-KR.json';
import nlNL from '../../../../locales/nl-NL.json';
import svSE from '../../../../locales/sv-SE.json';
import thTH from '../../../../locales/th-TH.json';
import zhCN from '../../../../locales/zh-CN.json';
import zhHK from '../../../../locales/zh-HK.json';
import msMY from '../../../../locales/ms-MY.json';
import idID from '../../../../locales/id-ID.json';
import viVN from '../../../../locales/vi-VN.json';

type Locales =
  | 'en-US'
  | 'da-DK'
  | 'de-DE'
  | 'en-AU'
  | 'en-CA'
  | 'en-GB'
  | 'es-ES'
  | 'es-MX'
  | 'fr-CA'
  | 'fr-FR'
  | 'it-IT'
  | 'ja-JP'
  | 'ko-KR'
  | 'nl-NL'
  | 'sv-SE'
  | 'th-TH'
  | 'zh-CN'
  | 'zh-HK'
  | 'ms-MY'
  | 'id-ID'
  | 'vi-VN';

type LanguagesResources = {
  [language in Locales]: ResourceLanguage;
};

const resources: LanguagesResources = {
  'en-US': { translation: enUS },
  'da-DK': { translation: daDK },
  'de-DE': { translation: deDE },
  'en-AU': { translation: enAU },
  'en-CA': { translation: enCA },
  'en-GB': { translation: enGB },
  'es-ES': { translation: esES },
  'es-MX': { translation: esMX },
  'fr-CA': { translation: frCA },
  'fr-FR': { translation: frFR },
  'it-IT': { translation: itIT },
  'ja-JP': { translation: jaJP },
  'ko-KR': { translation: koKR },
  'nl-NL': { translation: nlNL },
  'sv-SE': { translation: svSE },
  'th-TH': { translation: thTH },
  'zh-CN': { translation: zhCN },
  'zh-HK': { translation: zhHK },
  'ms-MY': { translation: msMY },
  'id-ID': { translation: idID },
  'vi-VN': { translation: viVN },
};

i18n
  .use(initReactI18next)
  .use(ICU)
  .init({
    resources,
    lng: DEFAULT_LOCALE,
    returnEmptyString: false,
    fallbackLng: DEFAULT_LOCALE,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
